import { ArrowUpRight, Check, Handshake, FileCheck2 } from "lucide-react";
import { Reveal, SectionHeading } from "../components/Reveal";
import { EDILIZIA_URL } from "../lib/api";

const COMPENSI = [
  {
    name: "AC START",
    text: "Nessuna percentuale: importo fisso di attivazione, detratto dal compenso finale se prosegui con acquisto o vendita.",
  },
  {
    name: "AC HUNT",
    text: "Attivazione più percentuale sul prezzo di acquisto a buon fine.",
  },
  {
    name: "AC SELECT",
    text: "Attivazione più percentuale sul prezzo di vendita a buon fine.",
  },
  {
    name: "AC INVEST",
    text: "Quota fissa di attivazione più quota sull'utile netto dell'operazione.",
  },
  {
    name: "AC MANAGEMENT",
    text: "Compenso concordato o percentuale sul computo metrico dei lavori edili.",
  },
];

const REGOLE = [
  {
    icon: Handshake,
    text: "Puoi scegliere liberamente professionisti e imprese: noi li selezioniamo con te e li coordiniamo.",
  },
  {
    icon: Check,
    text: "Non percepiamo commissioni di segnalazione dai professionisti e dalle imprese partner.",
  },
  {
    icon: FileCheck2,
    text: "I pagamenti a notaio, imprese e professionisti li effettui direttamente tu.",
  },
];

export function ImpresaPartnerSection() {
  return (
    <section id="impresa-partner" className="section" data-testid="impresa-partner-section">
      <div className="container-hub grid items-center gap-14 lg:grid-cols-[1.1fr_0.9fr]">
        <div>
          <SectionHeading
            eyebrow="Il cantiere"
            title={<>EDILIZIA CANNINO, <span className="gold-text">IMPRESA PARTNER.</span></>}
            lead="Edilizia Cannino è un'impresa di famiglia attiva da oltre trent'anni ed è un partner esterno ad A.C. HUB. Sei libero di chiedere altri preventivi: li coordiniamo e li confrontiamo con lo stesso metodo, e il contratto dei lavori lo firmi direttamente con l'impresa che scegli."
          />
          <Reveal delay={0.25}>
            <a
              href={EDILIZIA_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="impresa-website-link"
              className="btn btn-outline mt-9"
            >
              Visita ediliziacannino.com
              <ArrowUpRight size={14} />
            </a>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="border border-[#c9a45c]/25 bg-[#0d0d0d] p-7 sm:p-9" data-testid="impresa-partner-card">
            <p className="eyebrow">Contratto diretto</p>
            <p className="mt-5 text-[15px] leading-relaxed text-[#dedbd4]">
              Il contratto dei lavori lo firmi direttamente con l'impresa che scegli: i tempi e i costi dei lavori
              sono quelli definiti nel contratto tra te e l'impresa.
            </p>
            <p className="mt-4 text-[15px] leading-relaxed text-[#dedbd4]">
              I pagamenti a imprese e professionisti li effettui direttamente tu: non percepiamo commissioni di
              segnalazione dai partner.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CompensiSection() {
  return (
    <section id="compensi" className="section" data-testid="compensi-section">
      <div className="container-hub">
        <SectionHeading
          eyebrow="Come lavoriamo"
          title={<>LAVORIAMO PER UNA SOLA PARTE: <span className="gold-text">LA TUA.</span></>}
          lead="Prima di firmare sai già come funziona il percorso e come veniamo ricompensati. Nessuna sorpresa: tutto scritto, tutto chiaro."
          center
        />

        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {COMPENSI.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.07}>
              <div className="card-hub flex min-h-[210px] flex-col p-6" data-testid={`compenso-${c.name.toLowerCase()}`}>
                <span className="font-serif text-[19px] text-gold-light">{c.name}</span>
                <p className="mt-4 text-[13px] leading-relaxed text-[#c9c6bf]">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 grid gap-px border border-[#c9a45c]/22 bg-[#c9a45c]/22 md:grid-cols-3">
          {REGOLE.map((r) => (
            <Reveal key={r.text} className="bg-[#0b0b0b]">
              <div className="flex min-h-[130px] items-start gap-4 p-6">
                <r.icon size={17} strokeWidth={1.6} className="mt-0.5 shrink-0 text-gold" />
                <p className="text-[13px] leading-relaxed text-[#dedbd4]">{r.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
